import { useGetResolution886ReviewResults } from '@/hooks/v2/resolution-886';
import { useResolution886Report } from '@/context/Resolution886Report';

export const useGetInitialComment = () => {
	const { report, lastReviewId } = useResolution886Report();

	const { data: reviewResults } = useGetResolution886ReviewResults({
		report_id: report?.id,
		review_id: lastReviewId || '',
		company_id: report?.company?.id,
		organization_id: report?.organization?.id
	});

	const comment = reviewResults?.comment;

	return { comment };
};
